import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import "./AllPostAdmin.css";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditPost } from "./allPostAdminEdit";

function AllAdminPost({ match }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [selectedData, setSelectedData] = useState({});

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const postData = await api.postGetAdmin(payload);
      setData(postData.post || []);
      setnoOfPost(postData.count || 0);
      setLimit(postData.limit || 10);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setData([]);
      setnoOfPost(0);
    }
  };

  const deletePost = async (id) => {
    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this crypto trade?",
      );
      if (isConfirmed) {
        setLoader(true);
        const payload = { id: id };
        await api.postDelete(payload);
        getPosts();
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  return (
    <>
      <div className="container-fluid crypto-trades-admin">
        {/* Header Section */}
        <div className="crypto-trades-header">
          <div className="content-of-header">
            <div className="title-section">
              <h1 className="crypto-trades-title">
                <i className="fas fa-chart-line crypto-trades-icon"></i>
                Crypto Trades ({noOfPost})
              </h1>
              <p className="crypto-trades-subtitle">
                Manage and monitor all cryptocurrency trading posts
              </p>
            </div>
            <Link className="crypto-trades-add-btn" to={"/admin/addpost"}>
              <i className="fas fa-plus-circle"></i>
              Add Crypto Trade
            </Link>
          </div>

          {/* Stats Cards */}
          <div className="crypto-trades-stats">
            <div className="col-lg-4">
              <div className="stat-card">
                <div className="stat-icon total-trades-icon">
                  <i className="fas fa-coins"></i>
                </div>
                <div className="stat-content">
                  <h3 className="stat-number">{noOfPost}</h3>
                  <p className="stats-label">Total Trades</p>
                </div>
              </div>
            </div>
            {/* <div className="stat-card">
              <div className="stat-icon image-trades-icon">
                <i className="fas fa-image"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">
                  {data.filter((item) => item.imageTitle).length}
                </h3>
                <p className="stats-label">With Images</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon video-trades-icon">
                <i className="fas fa-video"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">
                  {data.filter((item) => item.video).length}
                </h3>
                <p className="stats-label">With Videos</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon file-trades-icon">
                <i className="fas fa-file-alt"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">
                  {data.filter((item) => item.pdfFile).length}
                </h3>
                <p className="stats-label">With Files</p>
              </div>
            </div> */}
          </div>
        </div>

        {/* Table Section */}
        <div className="crypto-trades-table-container">
          <Table
            data={data}
            setPage={setPage}
            page={page}
            noOfPost={noOfPost}
            limit={limit}
            deletePost={deletePost}
            handleShowEdit={handleShowEdit}
          />
        </div>
      </div>

      {loader && <Loader />}

      {/* Edit Modal */}
      <Modal
        show={showEdit}
        size="lg"
        onHide={handleCloseEdit}
        centered
        className="crypto-trades-modal"
      >
        <Modal.Body>
          <div className="modal-header-custom">
            <div className="modal-title-section">
              <h5 className="modal-title">
                <i className="fas fa-edit me-2"></i>
                Edit Crypto Trade
              </h5>
              <p className="modal-subtitle">Update trade details</p>
            </div>
            <button className="modal-close-btn" onClick={handleCloseEdit}>
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="modal-body-custom">
            <EditPost
              getData={getPosts}
              setShow={setShowEdit}
              editData={selectedData}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

// const Table = ({
//   data,
//   page,
//   setPage,
//   noOfPost,
//   limit,
//   deletePost,
//   handleShowEdit,
// }) => {
//   const handleChange = (event, value) => {
//     setPage(value);
//   };

//   const formatDate = (date) => {
//     if (!date) return "N/A";
//     let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
//     return dateTemp;
//   };

//   return (
//     <>
//       <div className="table-card">
//         <div className="table-responsive">
//           <table className="table crypto-trades-table">
//             <thead>
//               <tr>
//                 <th scope="col">Image</th>
//                 <th scope="col">Video</th>
//                 <th scope="col">File</th>
//                 <th scope="col">Description</th>
//                 <th scope="col">Created By</th>
//                 <th scope="col">Created At</th>
//                 <th scope="col" className="text-center">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {data && data.length > 0 ? (
//                 data.map((item, key) => (
//                   <tr key={key} className="crypto-trade-row">
//                     <td>
//                       {item.imageTitle ? (
//                         <div className="image-gallery">
//                           {item.imageTitle.split(",").map((val, idx) => (
//                             <div className="image-preview" key={idx}>
//                               <img
//                                 src={`${process.env.REACT_APP_S3URL}/img_${val}.${
//                                   item.imageFormat?.split(",")[idx] || "jpg"
//                                 }`}
//                                 alt={`Trade ${key + 1} - Image ${idx + 1}`}
//                                 className="trade-image"
//                               />
//                             </div>
//                           ))}
//                         </div>
//                       ) : (
//                         <div className="no-content-placeholder">
//                           <i className="fas fa-image"></i>
//                           <span>No Image</span>
//                         </div>
//                       )}
//                     </td>
//                     <td>
//                       {item?.video ? (
//                         <div className="video-container">
//                           <div
//                             className="video-wrapper"
//                             dangerouslySetInnerHTML={{
//                               __html: item?.video,
//                             }}
//                           />
//                         </div>
//                       ) : (
//                         <div className="no-content-placeholder">
//                           <i className="fas fa-video"></i>
//                           <span>No Video</span>
//                         </div>
//                       )}
//                     </td>
//                     <td>
//                       {item?.pdfFile ? (
//                         <div className="file-download-card">
//                           <a
//                             href={`${process.env.REACT_APP_S3URL}/${item?.pdfFile}`}
//                             download={item?.pdfFile.split("_")[0]}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="file-link"
//                           >
//                             <div className="file-icon">
//                               {item?.pdfFile.includes(".pdf") ? (
//                                 <i className="fas fa-file-pdf pdf-icon"></i>
//                               ) : (
//                                 <i className="fas fa-file-word word-icon"></i>
//                               )}
//                             </div>
//                             <div className="file-info">
//                               <span className="file-name">
//                                 {item?.pdfFile.split("_")[0]}
//                               </span>
//                               <span className="file-size">Download</span>
//                             </div>
//                           </a>
//                         </div>
//                       ) : (
//                         <div className="no-content-placeholder">
//                           <i className="fas fa-file"></i>
//                           <span>No File</span>
//                         </div>
//                       )}
//                     </td>
//                     <td>
//                       <div className="description-container">
//                         {item?.description ? (
//                           <div
//                             className="description-content"
//                             dangerouslySetInnerHTML={{
//                               __html: item?.description,
//                             }}
//                           />
//                         ) : (
//                           <div className="no-content-placeholder">
//                             <i className="fas fa-align-left"></i>
//                             <span>No Description</span>
//                           </div>
//                         )}
//                       </div>
//                     </td>
//                     <td>
//                       <div className="creator-info">
//                         <div className="creator-avatar">
//                           <i className="fas fa-user-circle"></i>
//                         </div>
//                         <div className="creator-details">
//                           <span className="creator-email">
//                             {item?.createdBy?.email || "N/A"}
//                           </span>
//                           <span className="creator-role">Admin</span>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="date-info">
//                         <div className="date-icon">
//                           <i className="fas fa-calendar-alt"></i>
//                         </div>
//                         <div className="date-details">
//                           <span className="date-formatted">
//                             {formatDate(item?.createdAt)}
//                           </span>
//                           <span className="time-ago">
//                             {moment(item?.createdAt).fromNow()}
//                           </span>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn edit-btn"
//                           onClick={() => handleShowEdit(item)}
//                           title="Edit Trade"
//                         >
//                           <i className="fas fa-edit"></i>
//                         </button>
//                         <button
//                           className="action-btn delete-btn"
//                           onClick={() => deletePost(item?._id)}
//                           title="Delete Trade"
//                         >
//                           <i className="fas fa-trash-alt"></i>
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr className="no-data-row">
//                   <td colSpan="7">
//                     <div className="empty-state">
//                       <div className="empty-state-icon">
//                         <i className="fas fa-coins"></i>
//                       </div>
//                       <h3 className="empty-state-title">No Crypto Trades Found</h3>
//                       <p className="empty-state-description">
//                         Start by adding your first crypto trade
//                       </p>
//                       <Link className="empty-state-btn" to={"/admin/addpost"}>
//                         <i className="fas fa-plus"></i>
//                         Add First Trade
//                       </Link>
//                     </div>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {data && data.length > 0 && noOfPost > limit && (
//           <div className="pagination-container">
//             <Stack spacing={2}>
//               <Pagination
//                 count={Math.ceil(noOfPost / limit)}
//                 page={page}
//                 onChange={handleChange}
//                 color="primary"
//                 sx={{
//                   '& .MuiPaginationItem-root.Mui-selected': {
//                     backgroundColor: '#10b981',
//                     color: 'white',
//                     '&:hover': {
//                       backgroundColor: '#059669',
//                     }
//                   },
//                   '& .MuiPaginationItem-root': {
//                     '&:hover': {
//                       backgroundColor: '#d1fae5',
//                       color: '#059669',
//                     }
//                   }
//                 }}
//               />
//             </Stack>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

const Table = ({
  data,
  page,
  setPage,
  noOfPost,
  limit,
  deletePost,
  handleShowEdit,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  // ── Trade detail renderer ─────────────────────────────────────────
  const renderTradeDetails = (item) => {
    if (!item.tradeType) {
      return (
        <div className="no-content-placeholder">
          <i className="fas fa-chart-bar"></i>
          <span>No Trade</span>
        </div>
      );
    }

    if (item.tradeType === "spot" && item.spotTrade) {
      const s = item.spotTrade;
      return (
        <div className="trade-details-card trade-spot">
          <div className="trade-badge spot-badge">
            <i className="fas fa-coins"></i> Spot
          </div>
          <div className="trade-rows">
            {s.exchange && (
              <div className="trade-row">
                <span className="tl">Exchange</span>
                <span className="tv">{s.exchange}</span>
              </div>
            )}
            <div className="trade-row">
              <span className="tl">Coin</span>
              <span className="tv coin-label">{s.coin}</span>
            </div>
            <div className="trade-row">
              <span className="tl">Entry Price</span>
              <span className="tv">${s.entryPrice?.toLocaleString()}</span>
            </div>
            <div className="trade-row">
              <span className="tl">Take Profit</span>
              <span className="tv green-val">
                ${s.takeProfit?.toLocaleString()}
              </span>
            </div>
            <div className="trade-row">
              <span className="tl">Filled (USDT)</span>
              <span className="tv">
                ${s.filledAmountUSDT?.toLocaleString()}
              </span>
            </div>
            <div className="trade-row">
              <span className="tl">Filled (Coin)</span>
              <span className="tv">{s.filledQuantityCoin}</span>
            </div>
          </div>
        </div>
      );
    }

    if (item.tradeType === "futures" && item.futuresTrade) {
      const f = item.futuresTrade;
      const statusClass =
        {
          Open: "status-open",
          Closed: "status-closed",
          "TP Hit": "status-tp",
          "SL Hit": "status-sl",
        }[f.status] || "";

      return (
        <div className="trade-details-card trade-futures">
          <div className="trade-badge futures-badge">
            <i className="fas fa-bolt"></i> Futures
          </div>
          <div className="trade-rows">
            {f.exchange && (
              <div className="trade-row">
                <span className="tl">Exchange</span>
                <span className="tv">{f.exchange}</span>
              </div>
            )}
            <div className="trade-row">
              <span className="tl">Coin</span>
              <span className="tv coin-label">{f.coin}</span>
            </div>
            <div className="trade-row">
              <span className="tl">Position</span>
              <span
                className={`tv position-label ${f.positionType === "Long" ? "pos-long" : "pos-short"}`}
              >
                {f.positionType === "Long" ? "▲" : "▼"} {f.positionType}
              </span>
            </div>
            {f.leverage && (
              <div className="trade-row">
                <span className="tl">Leverage</span>
                <span className="tv">{f.leverage}x</span>
              </div>
            )}
            {f.marginMode && (
              <div className="trade-row">
                <span className="tl">Margin</span>
                <span className="tv">{f.marginMode}</span>
              </div>
            )}
            <div className="trade-row">
              <span className="tl">Entry</span>
              <span className="tv">${f.entryPrice?.toLocaleString()}</span>
            </div>
            <div className="trade-row">
              <span className="tl">SL</span>
              <span className="tv red-val">
                ${f.stopLoss?.toLocaleString()}
              </span>
            </div>
            <div className="trade-row">
              <span className="tl">TP</span>
              <span className="tv green-val">
                ${f.takeProfit?.toLocaleString()}
              </span>
            </div>
            {f.marginUsedUSDT && (
              <div className="trade-row">
                <span className="tl">Margin Used</span>
                <span className="tv">
                  ${f.marginUsedUSDT?.toLocaleString()}
                </span>
              </div>
            )}
            {f.positionSizeUSDT && (
              <div className="trade-row">
                <span className="tl">Position Size</span>
                <span className="tv">
                  ${f.positionSizeUSDT?.toLocaleString()}
                </span>
              </div>
            )}
            {f.liquidationPrice && (
              <div className="trade-row">
                <span className="tl">Liquidation</span>
                <span className="tv red-val">
                  ${f.liquidationPrice?.toLocaleString()}
                </span>
              </div>
            )}
            <div className="trade-row">
              <span className="tl">Status</span>
              <span className={`tv trade-status ${statusClass}`}>
                {f.status}
              </span>
            </div>
            {f.pnlUSDT != null && (
              <div className="trade-row">
                <span className="tl">PNL</span>
                <span
                  className={`tv ${f.pnlUSDT >= 0 ? "green-val" : "red-val"}`}
                >
                  {f.pnlUSDT >= 0 ? "+" : ""}
                  {f.pnlUSDT} USDT
                </span>
              </div>
            )}
            {f.roiPercent != null && (
              <div className="trade-row">
                <span className="tl">ROI</span>
                <span
                  className={`tv ${f.roiPercent >= 0 ? "green-val" : "red-val"}`}
                >
                  {f.roiPercent >= 0 ? "+" : ""}
                  {f.roiPercent}%
                </span>
              </div>
            )}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <div className="table-card">
        <div className="table-responsive">
          <table className="table crypto-trades-table">
            <thead>
              <tr>
                <th scope="col">Image</th>
                <th scope="col">Video</th>
                <th scope="col">File</th>
                <th scope="col">Description</th>
                <th scope="col">Trade Details</th> {/* ── NEW ── */}
                <th scope="col">Created By</th>
                <th scope="col">Created At</th>
                <th scope="col" className="text-center">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, key) => (
                  <tr key={key} className="crypto-trade-row">
                    {/* Image — UNCHANGED */}
                    <td>
                      {item.imageTitle ? (
                        <div className="image-gallery">
                          {item.imageTitle.split(",").map((val, idx) => (
                            <div className="image-preview" key={idx}>
                              <img
                                src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                                  item.imageFormat?.split(",")[idx] || "jpg"
                                }`}
                                alt={`Trade ${key + 1} - Image ${idx + 1}`}
                                className="trade-image"
                              />
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="no-content-placeholder">
                          <i className="fas fa-image"></i>
                          <span>No Image</span>
                        </div>
                      )}
                    </td>

                    {/* Video — UNCHANGED */}
                    <td>
                      {item?.video ? (
                        <div className="video-container">
                          <div
                            className="video-wrapper"
                            dangerouslySetInnerHTML={{ __html: item?.video }}
                          />
                        </div>
                      ) : (
                        <div className="no-content-placeholder">
                          <i className="fas fa-video"></i>
                          <span>No Video</span>
                        </div>
                      )}
                    </td>

                    {/* File — UNCHANGED */}
                    <td>
                      {item?.pdfFile ? (
                        <div className="file-download-card">
                          <a
                            href={`${process.env.REACT_APP_S3URL}/${item?.pdfFile}`}
                            download={item?.pdfFile.split("_")[0]}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="file-link"
                          >
                            <div className="file-icon">
                              {item?.pdfFile.includes(".pdf") ? (
                                <i className="fas fa-file-pdf pdf-icon"></i>
                              ) : (
                                <i className="fas fa-file-word word-icon"></i>
                              )}
                            </div>
                            <div className="file-info">
                              <span className="file-name">
                                {item?.pdfFile.split("_")[0]}
                              </span>
                              <span className="file-size">Download</span>
                            </div>
                          </a>
                        </div>
                      ) : (
                        <div className="no-content-placeholder">
                          <i className="fas fa-file"></i>
                          <span>No File</span>
                        </div>
                      )}
                    </td>

                    {/* Description — UNCHANGED */}
                    <td>
                      <div className="description-container">
                        {item?.description ? (
                          <div
                            className="description-content"
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          />
                        ) : (
                          <div className="no-content-placeholder">
                            <i className="fas fa-align-left"></i>
                            <span>No Description</span>
                          </div>
                        )}
                      </div>
                    </td>

                    {/* ── NEW: Trade Details ── */}
                    <td>{renderTradeDetails(item)}</td>

                    {/* Created By — UNCHANGED */}
                    <td>
                      <div className="creator-info">
                        <div className="creator-avatar">
                          <i className="fas fa-user-circle"></i>
                        </div>
                        <div className="creator-details">
                          <span className="creator-email">
                            {item?.createdBy?.email || "N/A"}
                          </span>
                          <span className="creator-role">Admin</span>
                        </div>
                      </div>
                    </td>

                    {/* Created At — UNCHANGED */}
                    <td>
                      <div className="date-info">
                        <div className="date-icon">
                          <i className="fas fa-calendar-alt"></i>
                        </div>
                        <div className="date-details">
                          <span className="date-formatted">
                            {formatDate(item?.createdAt)}
                          </span>
                          <span className="time-ago">
                            {moment(item?.createdAt).fromNow()}
                          </span>
                        </div>
                      </div>
                    </td>

                    {/* Actions — UNCHANGED */}
                    <td>
                      <div className="action-buttons">
                        <button
                          className="action-btn edit-btn"
                          onClick={() => handleShowEdit(item)}
                          title="Edit Trade"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="action-btn delete-btn"
                          onClick={() => deletePost(item?._id)}
                          title="Delete Trade"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="no-data-row">
                  <td colSpan="8">
                    <div className="empty-state">
                      <div className="empty-state-icon">
                        <i className="fas fa-coins"></i>
                      </div>
                      <h3 className="empty-state-title">
                        No Crypto Trades Found
                      </h3>
                      <p className="empty-state-description">
                        Start by adding your first crypto trade
                      </p>
                      <Link className="empty-state-btn" to={"/admin/addpost"}>
                        <i className="fas fa-plus"></i> Add First Trade
                      </Link>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination — UNCHANGED */}
        {data && data.length > 0 && noOfPost > limit && (
          <div className="pagination-container">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
                color="primary"
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#10b981",
                    color: "white",
                    "&:hover": { backgroundColor: "#059669" },
                  },
                  "& .MuiPaginationItem-root": {
                    "&:hover": { backgroundColor: "#d1fae5", color: "#059669" },
                  },
                }}
              />
            </Stack>
          </div>
        )}
      </div>
    </>
  );
};

export default AllAdminPost;
